import { createSelector } from '@reduxjs/toolkit';
import * as selectSession from 'store/slices/session/selectSession';

import { CONFIG_SLICE_NAME } from '../slicesNames';

export const api = (state) => state[CONFIG_SLICE_NAME].values.API_TOKEN;
export const azureMaps = (state) => state[CONFIG_SLICE_NAME].values.AZURE_MAPS_KEY;
export const { anonymousAnalyticsToken, accessToken } = selectSession; // re-exporting for convenience

// When sending an integration token we always prefer the access token if it is available.
// When it is not available, the anonymous analytics token is used.
// The anonymous analytics token is useful for connecting analytics events to a user, but does NOT link back to a member session in the database.
export const integrationToken = createSelector(
  [accessToken, anonymousAnalyticsToken],
  (accessTokenValue, anonymousAnalyticsTokenValue) =>
    accessTokenValue || anonymousAnalyticsTokenValue
);
